import { render } from "./NewEventTemplate.vue?vue&type=template&id=0b0350cc"
import script from "./NewEventTemplate.vue?vue&type=script&lang=js"
export * from "./NewEventTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src860361777/src/isi_presenter_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__